export default __webpack_public_path__ + "static/media/back.d6ca8ad9.png";